import { getDataSimple } from "../helpers/apiHelperV3";
import { urls } from "./urls";

const API_TURNOVER = urls.cashier.API_TURNOVER();
const API_GATEWAYS = urls.cashier.API_GATEWAYS();
const API_GATEWAYS_GLOBAL = urls.cashier.API_GATEWAYS_GLOBAL();

/**
 * Fetch monthly turnover
 */
export const fetchMonthlyTurnover = (): any => {
  const url = API_TURNOVER;
  return getDataSimple(url);
};

/**
 * Fetch gateways
 */
export const fetchGateways = (): any => {
  const url = API_GATEWAYS;
  return getDataSimple(url);
};

/**
 * Fetch global gateways
 */
export const fetchGlobalGateways = (): any => {
  const url = API_GATEWAYS_GLOBAL;
  return getDataSimple(url);
};
